import React, {useCallback, useEffect, useState} from 'react';
import {Button, Card, CardBody, CardHeader, CardTitle, Col, Table} from "reactstrap";
import {SearchApi} from "../../services/services";

const ResultTable = (props) => {
    const [result, setResult] = useState([])
    const Result = useCallback(async () => {        
        const params = {
            categoryId : props.category,
            subjectId : props.subject,
            features : props.filters
        }
        const result = await SearchApi(params)
        setResult(result?.data)
    })

    useEffect(() => {
        Result()
    }, [])

    const setTableData = (tableData) => {
        props.onSelect(tableData)
    }

    return (
        <Col xs={12} sm={12}>
            <Card>
                <CardHeader>
                    <CardTitle className="text-right" tag="h4">نتیجه جستجو</CardTitle>
                </CardHeader>
                <CardBody>
                    <Table className="tablesorter " >
                        <thead className="text-primary">
                        <tr>
                            <th className="text-right">عنوان</th>
                            <th className="text-center">نمایش</th>
                        </tr>
                        </thead>
                        <tbody>
                        {result && result.map((r, index) => (
                            <tr key={index}>
                                <td className={'text-right'}>{r.title}</td>
                                <td className={'text-center'}>
                                    <Button onClick={() => setTableData(r)}>
                                        <i className="tim-icons icon-alert-circle-exc"/>

                                    </Button>
                                </td>
                            </tr>
                        ))
                        }
                        </tbody>
                    </Table>
                </CardBody>
            </Card>

        </Col>
    )
};

export default ResultTable;